// Ensure intl-tel-input search box has proper padding
const ensureIntlTelInputStyle = () => {
  if (document.getElementById("iti-search-style")) return;
  const style = document.createElement("style");
  style.id = "iti-search-style";
  style.innerHTML = `.iti__search-input { padding-left: 2.5rem !important; }`;
  document.head.appendChild(style);
};

// Initialize international phone number inputs with country selector
const initPhoneInputs = () => {
  const phoneInputs = Array.from(
    document.querySelectorAll('input[id$="_phone"]'),
  );
  if (phoneInputs.length === 0 || typeof window.intlTelInput !== "function")
    return;

  ensureIntlTelInputStyle();

  const options = {
    initialCountry: "my",
    separateDialCode: true,
    autoPlaceholder: "polite",
    preferredCountries: ["my", "sg"],
    excludeCountries: ["il", "kp"],
    nationalMode: false,
    loadUtils: () =>
      import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.10.10/build/js/utils.js"),
  };

  phoneInputs.forEach((telInput) => {
    const iti = window.intlTelInput(telInput, options);
    const form = telInput.form || document;

    const updatePhoneValue = () => {
      const updatedFullPhone = iti.getNumber();
      telInput.value = updatedFullPhone;
    };

    form.addEventListener("submit", updatePhoneValue);
  });
};

// Toggle visibility of "Other" text fields when "Others" is selected in dropdowns
const initOtherInputs = () => {
  const otherInputs = document.querySelectorAll('input[id$="_other"]');

  otherInputs.forEach((otherInput) => {
    const mainInputId = otherInput.id.replace("_other", "");
    const mainInput = document.getElementById(mainInputId);
    if (!mainInput) return;

    const wrapperId = `${otherInput.id.replace("user_", "")}_wrapper`;
    const wrapper =
      document.getElementById(wrapperId) ||
      otherInput.closest(`.${otherInput.id}`);
    if (!wrapper) return;

    const toggleVisibility = () => {
      if (mainInput.tagName !== "SELECT") return;

      const selectedOption = mainInput.options[mainInput.selectedIndex];
      const text = selectedOption?.text?.toLowerCase() || "";
      const value = mainInput.value?.toLowerCase() || "";
      const isOtherSelected = text.includes("other") || value === "others";

      if (isOtherSelected) {
        wrapper.classList.remove("hidden");
        otherInput.required = true;
      } else {
        wrapper.classList.add("hidden");
        otherInput.required = false;
        otherInput.value = "";
      }
    };

    mainInput.addEventListener("change", toggleVisibility);
    toggleVisibility();
  });
};

// Enable submit button only when PDPA checkbox is checked
const initPdpaCheckbox = () => {
  const pdpaCheck = document.getElementById("pdpa_checkbox");
  const submitBtn = document.getElementById("signup-submit-btn");
  if (!pdpaCheck || !submitBtn) return;

  pdpaCheck.addEventListener("change", (e) => {
    submitBtn.disabled = !e.target.checked;
  });
};

// Smooth scroll to first invalid field on form submission
const initFormValidation = () => {
  const form = document.querySelector('form#new_user, form[id^="edit_user"]');
  if (!form) return;

  form.addEventListener("submit", (e) => {
    if (form.checkValidity()) return;

    e.preventDefault();
    e.stopPropagation();

    const firstInvalid = form.querySelector(":invalid");
    if (!firstInvalid) return;

    const NAVBAR_HEIGHT = document.querySelector("nav")?.offsetHeight || 80;
    const BANNER_HEIGHT =
      document.querySelector(".page-hero")?.offsetHeight || 120;
    const EXTRA_PADDING = 20;
    const offset = NAVBAR_HEIGHT + BANNER_HEIGHT + EXTRA_PADDING;
    const y =
      firstInvalid.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: y, behavior: "smooth" });
    setTimeout(() => firstInvalid.focus({ preventScroll: true }), 600);
  });
};

// Initialize all user form functionality
const initUser = () => {
  const userForm = document.querySelector(
    'form#new_user, form[id^="edit_user"]',
  );
  if (!userForm) return;

  initPhoneInputs();
  initOtherInputs();
  initPdpaCheckbox();
  initFormValidation();
};

export default initUser;
